<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="user_verify"
    data-name="user verify"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_8358" data-name="Path 8358" d="M0,0H24V24H0Z" fill="none" />
    <g id="Group_972" data-name="Group 972" transform="translate(7.171 6.187)">
      <path
        id="Path_8360"
        data-name="Path 8360"
        d="M5,18.607H5a3.054,3.054,0,0,1,3.054-3.054h3.507a3.054,3.054,0,0,1,3.054,3.054h0"
        transform="translate(-5 -7.619)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8361"
        data-name="Path 8361"
        d="M12.733,4.855a2.919,2.919,0,1,1-4.128,0,2.919,2.919,0,0,1,4.128,0"
        transform="translate(-5.861 -4)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path
      id="Path_8359"
      data-name="Path 8359"
      d="M7.5,3H5A2,2,0,0,0,3,5V7.5m0,9V19a2,2,0,0,0,2,2H7.5m9,0H19a2,2,0,0,0,2-2V16.5m0-9V5a2,2,0,0,0-2-2H16.5"
      transform="translate(0 0)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
